import { render, staticRenderFns } from "./ReceiveInventory.vue?vue&type=template&id=fe118d16&scoped=true"
import script from "./ReceiveInventory.vue?vue&type=script&lang=js"
export * from "./ReceiveInventory.vue?vue&type=script&lang=js"
import style0 from "./ReceiveInventory.vue?vue&type=style&index=0&id=fe118d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe118d16",
  null
  
)

export default component.exports